import type { CoveredRenderingConfig } from '../config/ui.config';

/**
 * Decides per frame whether the 3D scene is rendered (pure logic, no Babylon). Visible scene: every frame.
 * Hidden behind the opaque loading / start screen: every frame for the warm-up after it got covered or changed
 * (shaders compile, a switched character loads its materials), then only one frame per `frameInterval`.
 */
export class CoveredSceneThrottle {
  private sinceWake = 0;
  private sinceFrame = 0;

  constructor(private readonly config: CoveredRenderingConfig) {}

  /** The hidden scene changed (e.g. another character): render every frame again for the warm-up. */
  wake(): void {
    this.sinceWake = 0;
  }

  shouldRender(dt: number, covered: boolean): boolean {
    if (!covered) {
      this.sinceWake = 0;
      this.sinceFrame = 0;
      return true;
    }
    this.sinceWake += dt;
    this.sinceFrame += dt;
    if (this.sinceWake <= this.config.warmupSeconds || this.sinceFrame >= this.config.frameInterval) {
      this.sinceFrame = 0;
      return true;
    }
    return false;
  }
}
